import { render, staticRenderFns } from "./ProductsByCategory.vue?vue&type=template&id=7edb8ae6&"
import script from "./ProductsByCategory.vue?vue&type=script&lang=js&"
export * from "./ProductsByCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports